<template>
  <div class="report-reason">
    <div class="guide-header">
      <span>{{ header }}</span>
    </div>

    <div class="guide-tip">
      <span>{{ tip1 }}</span>
    </div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="22">
        <img
          v-bind:src="$setPicSize(imgList[0])"
          @click="showBig(0)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
    <div class="guide-result">
      <span class="red">【官方提示】</span><span>{{ result1 }}</span>
    </div>
    <div class="guide-tip">
      <span>{{ tip2 }}</span>
    </div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="22">
        <img
          v-bind:src="$setPicSize(imgList[1])"
          @click="showBig(1)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
    <div class="guide-result">
      <span class="red">【官方提示】</span><span>{{ result2 }}</span>
    </div>
  </div>
</template>

<script>
import { Row, Col, ImagePreview } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import native from '@zz-common/native-adapter'

const tip1 = 'https://pic5.zhuanstatic.com/zhuanzh/f0b556bf-c37e-4c94-8240-e384be388ca1.png'
const tip2 = 'https://pic5.zhuanstatic.com/zhuanzh/f0b556bf-c37e-4c94-8240-e384be388ca1.png'
export default {
  name: 'uploadExample',
  data() {
    return {
      header:
          '近期有不法分子冒充转转官方进行欺诈，现将骗术整理如下，请您在交易中务必警惕以下不法行为，不轻易添加对方微信、不点击站外链接、遇事在平台内找官方客服帮助、在转转APP/小程序内交易，不盲从不轻信，转转平台期待与您一起携手保障平台安全、维护自身合法权益近期有不法分子冒充转转官方进行欺诈，现将骗术整理如下，请您在交易中务必警惕以下不法行为，不轻易添加对方微信、不点击站外链接、遇事在平台内找官方客服帮助、在转转APP/小程序内交易，不盲从不轻信，转转平台期待与您一起携手保障平台安全、维护自身合法权益。',
      tip1: '1、不点击站外链接！下单付款认准APP!',
      result1:
          '请您擦亮双眼尽可能在平台内沟通，不添加陌生微信，同时拒绝点击陌生链接，下单付款操作均在转转app内进行！',
      tip2: '2、转转客服在APP内！第三方客服都是骗子！',
      result2:
          '转转官方客服入口只有一个：APP中点击【我的--客服中心】，没有其他第三方客服入口，更没有个人微信号！引导到非官方客服，同时收取保证金/合约金/平台押金的都是骗子！任何与金钱相关的操作请在官方APP/官方小程序中进行，走转转担保交易，保障安全！',
      imgList: [tip1, tip2]
    }
  },
  components: { Col, Row },
  computed: {},
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    showBig(startPosition) {
      ImagePreview({
        images: this.imgList,
        startPosition,
        adaptApp: true
      })
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '转转防骗安全中心公告'
    })
  }
}
</script>

<style scoped lang="less">
  @import 'PreventFoolNotice.less';
</style>
